/* bz-lp-modular.js — Modular Focus LP interactions. Deferred, no deps. */
(function () {
  "use strict";
  function init() {
    var root = document.querySelector(".bz-lp");
    if (!root) return;

    /* read-progress bar */
    var bar = root.querySelector(".bz-lp__progress");
    if (bar) {
      var onScroll = function () {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        var pct = Math.min(100, Math.max(0, (h.scrollTop || window.pageYOffset) / max * 100));
        bar.style.width = pct + "%";
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    /* TOC collapse toggle */
    var toggle = root.querySelector(".bz-toc__toggle");
    if (toggle) {
      toggle.addEventListener("click", function () {
        var open = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!open));
        var list = toggle.nextElementSibling;
        if (list) list.style.display = open ? "none" : "block";
      });
      /* collapse by default on mobile */
      if (window.matchMedia("(max-width:560px)").matches) {
        toggle.setAttribute("aria-expanded", "false");
        if (toggle.nextElementSibling) toggle.nextElementSibling.style.display = "none";
      }
    }

    /* smooth anchor scroll */
    root.querySelectorAll('.bz-toc a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var t = document.getElementById(a.getAttribute("href").slice(1));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); }
      });
    });

    /* scroll-reveal — progressive enhancement; default (no JS) leaves all visible */
    if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      root.classList.add("bz-anim");
      var revIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("bz-in"); revIO.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      root.querySelectorAll("section, .bz-block").forEach(function (el) {
        if (el.classList.contains("bz-hero") || el.closest(".bz-hero")) return;
        el.classList.add("bz-reveal");
        revIO.observe(el);
      });
    }

    /* sticky ATC bar — reveal after hero leaves view, hide near final CTA */
    var sticky = root.querySelector(".bz-sticky");
    if (sticky && "IntersectionObserver" in window) {
      var hero = root.querySelector(".bz-hero");
      var final = root.querySelector(".bz-final");
      var pastHero = false, atFinal = false;
      var sync = function () { sticky.classList.toggle("show", pastHero && !atFinal); };
      if (hero) new IntersectionObserver(function (en) {
        pastHero = !en[0].isIntersecting; sync();
      }, { threshold: 0 }).observe(hero);
      if (final) new IntersectionObserver(function (en) {
        atFinal = en[0].isIntersecting; sync();
      }, { threshold: 0 }).observe(final);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
